import {
  boolean,
  index,
  integer,
  pgTable,
  text,
  timestamp,
} from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";
import { branches } from "./branches";

export const products = pgTable(
  "products",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    type: text("type", { enum: ["MENU", "RETAIL"] }).notNull(),
    name: text("name").notNull(),
    description: text("description"),
    imageUrl: text("image_url"),
    isActive: boolean("is_active").notNull().default(true),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("products_type_idx").on(t.type),
    index("products_active_idx").on(t.isActive),
  ],
);

export const productVariants = pgTable(
  "product_variants",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    productId: text("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    name: text("name").notNull(),
    sku: text("sku"),
    barcode: text("barcode"),
    basePriceLak: integer("base_price_lak").notNull(),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("product_variants_product_idx").on(t.productId),
    index("product_variants_sku_idx").on(t.sku),
    index("product_variants_barcode_idx").on(t.barcode),
  ],
);

export const branchPrices = pgTable(
  "branch_prices",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    branchId: text("branch_id")
      .notNull()
      .references(() => branches.id, { onDelete: "cascade" }),
    variantId: text("variant_id")
      .notNull()
      .references(() => productVariants.id, { onDelete: "cascade" }),
    overridePriceLak: integer("override_price_lak").notNull(),
    isActive: boolean("is_active").notNull().default(true),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("branch_prices_branch_variant_idx").on(t.branchId, t.variantId),
  ],
);

export const modifiers = pgTable("modifiers", {
  id: text("id")
    .primaryKey()
    .$defaultFn(() => nanoid()),
  name: text("name").notNull(),
  minSelect: integer("min_select").notNull().default(0),
  maxSelect: integer("max_select").notNull().default(1),
  isRequired: boolean("is_required").notNull().default(false),
  createdAt: timestamp("created_at", {
    withTimezone: true,
    mode: "date",
  }).notNull(),
  updatedAt: timestamp("updated_at", {
    withTimezone: true,
    mode: "date",
  }).notNull(),
});

export const modifierOptions = pgTable(
  "modifier_options",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    modifierId: text("modifier_id")
      .notNull()
      .references(() => modifiers.id, { onDelete: "cascade" }),
    name: text("name").notNull(),
    priceDeltaLak: integer("price_delta_lak").notNull().default(0),
    costDeltaLak: integer("cost_delta_lak"),
    stockDeltaRule: text("stock_delta_rule"),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [index("modifier_options_modifier_idx").on(t.modifierId)],
);

export const productModifierLinks = pgTable(
  "product_modifier_links",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    productId: text("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    modifierId: text("modifier_id")
      .notNull()
      .references(() => modifiers.id, { onDelete: "cascade" }),
    sortOrder: integer("sort_order").notNull().default(0),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("product_modifier_links_product_idx").on(t.productId),
    index("product_modifier_links_modifier_idx").on(t.modifierId),
  ],
);
